import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"2.5\" cy=\"3.998\" r=\"2.5\"></circle><path d=\"M8.5 5H23a1 1 0 0 0 0-2H8.5a1 1 0 0 0 0 2\"></path><circle cx=\"2.5\" cy=\"11.998\" r=\"2.5\"></circle><path d=\"M23 11H8.5a1 1 0 0 0 0 2H23a1 1 0 0 0 0-2\"></path><circle cx=\"2.5\" cy=\"19.998\" r=\"2.5\"></circle><path d=\"M23 19H8.5a1 1 0 0 0 0 2H23a1 1 0 0 0 0-2\"></path>", 6)
  ]))]))
}
export default { render: render }